import {
  type IStructuredLogBase,
  type IStructuredLogValidationResult,
  type IStructuredLogger,
  type TStructuredLogValidator,
} from '../types/structured-log-types';
import { checkifOriginIsWhitelisted } from './check-whitelist-origin';

/**
 * `handleStructuredLogEvent` handles the structured log event
 * @param event - event to handle the structured log data
 * @param logger - logger to log the structured log data
 */
export const handleStructuredLogEvent = <T extends IStructuredLogBase>(
  event: Event,
  logger: IStructuredLogger<T>,
  structuredLogValidator: TStructuredLogValidator<T>,
) => {
  const { detail } = event as CustomEvent<T>;

  if (!checkifOriginIsWhitelisted()) return;

  const { isValid, validValues, errorMessages }: IStructuredLogValidationResult<T> = structuredLogValidator(detail as T);

  if (isValid) {
    logger.log(validValues);
  } else {
    logger.error(validValues, errorMessages);
  }
};
